import { apiClient } from './client';
import { API_BASE_URL } from '../config/adminConfig';
import { downloadBlob, resolveDownloadFileName } from '../utils/downloadImage';

export async function fetchContents() {
  const { data } = await apiClient.get('/contents');
  return data;
}

export async function createContent({ activityId, imageFile }) {
  const formData = new FormData();
  formData.append('activity_id', String(activityId));
  formData.append('image', imageFile);

  const { data } = await apiClient.post('/contents', formData);
  return data;
}

export async function deleteContent(id) {
  const { data } = await apiClient.delete(`/contents/${id}`);
  return data;
}

export async function downloadContent(id, fallbackFileName = 'inmotion-photo') {
  const response = await apiClient.get(`/contents/${id}/download`, {
    responseType: 'blob',
  });

  const fileName = resolveDownloadFileName(
    response.headers['content-disposition'],
    fallbackFileName
  );

  downloadBlob(response.data, fileName);
}

export function extractContentFromResponse(data) {
  return data?.data ?? data;
}

export function extractContentsFromResponse(data) {
  const payload = data?.data ?? data;
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  return [];
}

export function getContentActivityId(content) {
  const activityId = content?.activity_id ?? content?.activity?.id;
  return activityId == null ? null : activityId;
}

export function mapContentToGalleryImage(content, activityName = '') {
  const alt = activityName || getContentActivityLabel(content);

  return {
    id: content.id,
    src: getContentImageUrl(content),
    alt,
  };
}

export function getContentImageUrl(content) {
  const image = content?.image_url || content?.image;
  if (!image) return '';

  if (/^https?:\/\//i.test(image)) {
    return image;
  }

  const origin = API_BASE_URL.replace(/\/api\/?$/, '');
  return image.startsWith('/') ? `${origin}${image}` : `${origin}/${image}`;
}

export function getContentActivityLabel(content) {
  if (content?.activity?.name) {
    return content.activity.name;
  }
  if (content?.activity_id) {
    return `Activity #${content.activity_id}`;
  }
  return 'Unknown activity';
}
